import { set } from 'lodash';
import { MutationTree } from 'vuex';

export const state = () => ({
  id: null,
  query: {
    where: {
      panel: [],
      category: [],
      trait: [],
      scoreType: [],
      sex: [],
      bioItSource: [],
      vendorBioItIds: []
    },
    sort: {
      panel: 'ASC'
    },
    offset: 0,
    limit: 10
  },
  table: {
    footer: {
      'items-per-page-options': [10, 25, 50, 100],
      'show-current-page': true,
      'show-first-last-page': true
    },
    filter: {
      keyword: '',
      panel: [],
      category: [],
      trait: [],
      scoreType: [],
      sex: [],
      bioItSource: [],
      vendorBioItIds: []
    },
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['panel'],
      sortDesc: [false],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: true
    }
  }
});

export type ProdigyMapperState = ReturnType<typeof state>;

export const mutations: MutationTree<ProdigyMapperState> = {
  changeId: (state, id) => (state.id = id),
  changeQuery: (state, query) => Object.assign(state.query, query),
  changeTableFilter: (state, filter) => {
    Object.assign(state.table, { filter });
    Object.assign(state.query, {
      where: {
        keyword: filter.keyword,
        panel: filter.panel,
        category: filter.category,
        trait: filter.trait,
        scoreType: filter.scoreType,
        sex: filter.sex,
        bioItSource: filter.bioItSource,
        vendorBioItIds: filter.vendorBioItIds
      }
    });
  },
  changeTableOptions: (state, options) => {
    Object.assign(state.table, { options });
    Object.assign(state.query, {
      sort: set({}, options.sortBy[0], options.sortDesc[0] ? 'DESC' : 'ASC'),
      limit: options.itemsPerPage,
      offset: (options.page - 1) * options.itemsPerPage
    });
  }
};
